<template>
  <div v-if="isLoadFinish || !need_request" class="default-channel-setting" :class="{'no-select': value == 0}">
    <el-select
      :value="value"
      placeholder="请选择频道"
      :popper-append-to-body="append_to_body"
      :popper-class="`channel-selector-popper ${popperClass}`"
      :key="updateSelectorKey"
      :disabled="disabled"
      @change="handleChannelChange"
      style="width: 100%"
      ref="channelSelector"
    >
      <div class="channel-info-wrapper perfix" slot="prefix" v-if="select_channel.channel_id">
        <img class="iconfont" :src="select_channel.channel_icon" v-if="select_channel.channel_icon && select_channel.channel_icon.indexOf('http') === 0"/>
        <i v-else-if="select_channel.icon_class" class="left-icon iconfont" :class="select_channel.icon_class"></i>
      </div>
      <el-option
        v-for="item in channelList"
        :key="item.channel_id"
        :label="item.channel_name"
        :value="item.channel_id"
        style="width: 100%"
      >
        <div class="channel-info-wrapper" :class="{'active': select_channel.channel_id === item.channel_id, [item_class]: true}">
          <img class="iconfont" :src="item.channel_icon" v-if="item.channel_icon && item.channel_icon.indexOf('http') === 0"/>
          <i v-else-if="item.icon_class" class="left-icon iconfont" :class="item.icon_class"></i>
          <div class="channel-name">{{ item.channel_name }}</div>
          <div class="group-name">{{ item.channel_group_name }}</div>
          <Radio class="radio-item" :active="select_channel.channel_id === item.channel_id"/>
        </div>
      </el-option>
    </el-select>
  </div>
  <div class="loading-wrapper h-[42px] bg-op-s2 pl-[12px] text-op-2 text-[14px] text-left tracking-[0.14px] leading-[42px] rounded-[5px] cursor-not-allowed" v-else>
    请选择频道
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Radio from '_com/menu/Radio'
import { getChannelIcon } from '_lib/constants/channel'
import { getFullChannelList } from "_api/channel";
import { ROLE_TYPES } from '_lib/constants/role';
import { CHANNEL_TYPES } from '_lib/constants/channel';
import { throttle } from '_lib/utils/utils';
import { findChannel } from '_js/find-channel';

export default {
  name: 'ChannelSelector',
  components: {
    Radio
  },
  props: {
    value: {
      type: String,
      default: '0'
    },
    channel_type: {
      type: Array,
      default: () => []
    },
    noSelectDesc: {
      type: String,
      default: ''
    },
    is_public: {
      type: Boolean,
      default: false
    },
    can_everyone_sendim: {
      type: Boolean,
      default: false
    },
    channels: {
      type: Array,
      default: () => []
    },
    need_page: {
      type: Boolean,
      default: false
    },
    need_request: {
      type: Boolean,
      default: true
    },
    append_to_body: {
      type: Boolean,
      default: false
    },
    item_class: {
      type: String,
      default: ''
    },
    popperClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      channelList: [],
      updateSelectorKey: 0,
      isLoadFinish: false,
      isLoading: false,
      isLoadAll: false,
      offset: 0,
      limit: 20,
      anchor_channel_id: null,
      select_channel: {},
    }
  },
  computed: {
    ...mapGetters(['cur_room_data', 'cur_roles_list', 'guidance_channel_list'])
  },
  watch: {
    value: {
      async handler(newVal) {
        const channelData = await findChannel(newVal)
        if(channelData) {
          this.setItemIconClass(channelData)
        }
        this.select_channel = channelData || {}
      },
      immediate: true
    }
  },
  async mounted() {
    if(this.noSelectDesc) {
      this.channelList.push({
        channel_id: '0',
        channel_name: this.noSelectDesc,
        channel_group_name: ''
      })
    }
    if(this.need_request) {
      await this.getChannels()
    } else {
      if(this.need_page) {
        this.channelList = this.channels.slice(0, this.limit)
      } else {
        this.channelList = this.channels
      }
    }
    if(this.need_page) {
      const channelData = await findChannel(this.value)
      const isExist = this.channelList?.some(item => item.channel_id == this.value)
      if(channelData && !isExist) {
        this.channelList.splice(this.noSelectDesc ? 1 : 0, 0, channelData)
      }
      this.initScrollbarEvent()
    }
  },
  beforeDestroy() {
    if(this.need_page) {
      this.removeScrollbarEvent()
    }
  },
  methods: {
    handleChannelChange(value) {
      this.$emit('change', value)
    },
    initScrollbarEvent() {
      const element = this.append_to_body ? document.body : this.$refs.channelSelector.$el
      const scrollbarEl = element.querySelector('.channel-selector-popper .el-scrollbar__wrap')
      scrollbarEl?.addEventListener('scroll', this.handleScroll)
    },
    removeScrollbarEvent() {
      const element = this.append_to_body ? document.body : this.$refs.channelSelector.$el
      const scrollbarEl = element.querySelector('.channel-selector-popper .el-scrollbar__wrap')
      scrollbarEl?.removeEventListener('scroll', this.handleScroll)
    },
    handleScroll: throttle(async function() {
      if(this.isLoading || this.isLoadAll) return
      const element = this.append_to_body ? document.body : this.$refs.channelSelector.$el
      const scrollbarEl = element.querySelector('.channel-selector-popper .el-scrollbar__wrap')
      if(scrollbarEl.scrollTop + scrollbarEl.clientHeight >= scrollbarEl.scrollHeight - 1000) {
        if(this.need_request) {
          this.getChannels()
        } else {
          this.offset += this.limit
          this.channelList.push(...this.channels.slice(this.offset, this.offset + this.limit).filter(item => item.channel_id !== this.select_channel.channel_id))
        }
      }
    }, 100),
    async getChannels() {
      if(this.isLoadAll) return
      this.isLoading = true
      let need_get_more = false
      let res = await getFullChannelList({
        room_id: this.cur_room_data.room_id,
        anchor_channel_id: this.anchor_channel_id,
        limit: this.need_page ? this.limit : 0,
      })
      if(res.data.status !== 'ok') return
      let channels = res.data.result.channels
      if(this.need_page) {
        this.anchor_channel_id = channels[channels.length - 1].channel_id
        if(channels.length < this.limit) {
          this.isLoadAll = true
        }
      } else {
        this.isLoadAll = true
      }
      channels = this.filterChannels(channels)
      channels.forEach(item => {
        this.setItemIconClass(item)
      })
      if(channels.length === 0) {
        need_get_more = true
      }
      
      this.channelList.push(...channels)
      // 如果第一次更新拿不够，则需要继续拿
      if(this.channelList.length < 9) {
        need_get_more = true
      }

      if(need_get_more) {
        this.getChannels()
      }
      this.isLoadFinish = true
      this.isLoading = false
    },
    filterChannels(channels) {
      const existIdList = this.channelList.map(item => item.channel_id)
      return channels.filter(item => {
        return this.judgeCanShow(item) && !existIdList.includes(item.channel_id)
      })
    },
    judgeCanShow(channel){
      let res = this.channel_type.includes(channel.channel_type)
      if(this.is_public) {
        res = res && !channel.is_private && !channel.password
        if(res) {
          const everyoneRole = this.cur_roles_list.find(
            (role) => role.type === ROLE_TYPES.everyone
          );
          res = !this.guidance_channel_list.includes(channel.channel_id) && this.$permission.judgeRole({
            role: everyoneRole,
            type: "ViewingChannel",
            channel_data: channel,
          })
        }
      }
      if(res && this.can_everyone_sendim) {
        const everyoneRole = this.cur_roles_list.find(
          (role) => role.type === ROLE_TYPES.everyone
        );
        res = this.$permission.judgeRole({
          type: 'SendIM',
          role: everyoneRole,
          channel_data: channel,
        })
      }
      return res
    },
    /**
     * 统一获取iconClass
     */
    setItemIconClass(channelItem) {
      if(channelItem.channel_type === CHANNEL_TYPES.group) {
        channelItem.icon_class = 'icon-file'
      } else {
        channelItem.icon_class = getChannelIcon(channelItem)
      }
    }
  }
}
</script>

<style lang="scss">
.default-channel-setting {
  &.no-select {
    .el-select {
      .el-input {
        .el-input__inner {
          padding-left: 12px !important;
          color: $d-tx-2 !important;
          background-color: $d-op-s2 !important;
        }
      }
    }
  }
  .el-select{
    position: relative;
  }
  .el-select-dropdown {
    min-width: 546px !important;
  }
  .channel-info-wrapper {
    display: flex;
    align-items: center;
    &.perfix {
      position: relative;
      top: 13px;
      left: 4px;
      .left-icon {
        color: $d-tx-1;
      }
    }
    &.active {
      .left-icon, .channel-name {
        color: $d-tx-1;
      }
      .group-name {
        color: $d-tx-2;
      }
    }
    .left-icon {
      font-size: 16px;
      margin-right: 6px;
      transform: none;
      color: $d-tx-4;
    }
    .channel-name {
      font-size: 14px;
      color: $d-tx-2;
      margin-right: 8px;
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .group-name {
      font-size: 12px;
      color: $d-tx-3;
      position: relative;
      max-width: 230px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .radio-item {
      margin-left: auto;
      width: auto;
    }
  }
}
</style>